/* eslint-disable import/max-dependencies */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useHandleRequest,
  useIsAffiliate,
} from "@fas/cpa-state-manager/redux/hooks";
import { useEnterPress } from "@fas/cpa-state-manager/hooks";
import {
  prepareFetchErrors,
  setErrors,
  addNotification,
  getFormData,
  setFormData,
} from "@fas/ui-framework";
import { CONTACT_INFO_FORM } from "../../constants";
import type { UserContactInfo } from "../../services/deprecatedApi";
import {
  getUserContactInfo,
  postUserContactInfo,
} from "../../services/deprecatedApi";

export type UseContactInfoFormHook = {
  isLoading: boolean;
  disabled: boolean;
  onSave: () => unknown;
  onKeyPress: (arg0: React.KeyboardEvent<any>) => unknown;
};
export const useContactInfoForm: () => UseContactInfoFormHook = () => {
  const dispatch = useDispatch();
  const { isLoading, changeLoading, onFail, onFinally } =
    useHandleRequest(CONTACT_INFO_FORM);
  const form = useSelector(
    (state) => getFormData(state, CONTACT_INFO_FORM) as UserContactInfo
  );
  useEffect(() => {
    changeLoading(true);
    getUserContactInfo()
      .then((data: UserContactInfo) =>
        dispatch(setFormData(CONTACT_INFO_FORM, data))
      )
      .catch(onFail)
      .finally(onFinally);
  }, []);

  const onSave = () => {
    changeLoading(true);
    const { phoneNumber, taxSSN } = form;
    postUserContactInfo({
      phoneNumber,
      taxSSN,
    })
      .then(() =>
        dispatch(
          addNotification({
            severity: "success",
            message: "Contact info updated successfully",
          })
        )
      )
      .catch(async (err: any) => {
        await onFail(err);

        if (
          err.isAxiosError &&
          err.response &&
          err.response.data &&
          err.response.data.errors &&
          Array.isArray(err.response.data.errors)
        ) {
          dispatch(setErrors(prepareFetchErrors(err.response.data.errors)));
        }
      })
      .finally(onFinally);
  };

  const { onKeyPress } = useEnterPress(onSave);
  return {
    isLoading,
    disabled: !useIsAffiliate(),
    onSave,
    onKeyPress,
  };
};
